import { createFileRoute } from '@tanstack/react-router';
import { JourneysGoalsHandoff } from '@/pages/workspaces/goals/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';
import { ShowGoalsGate } from './-goals-route';

// `/workspaces/last` must resolve before the embedded app mounts.
function JourneysGoalsIndexRoute() {
  return (
    <ShowGoalsGate>
      <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
        <JourneysGoalsHandoff />
      </LastWorkspaceResolver>
    </ShowGoalsGate>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/goals/')({
  component: JourneysGoalsIndexRoute,
});
